import React from 'react';
import { Stack } from '@mui/material';
import { PMByCenterChart, PMByCategoryChart, PMCostBreakdownChart, PMComplianceByCenterChart } from '../../charts';
import { PMReportSummaryView, PMCenterBreakdownView, PMCategoryBreakdownView } from '../../../../../services/ReportingService';

interface PMReportChartsProps {
  summaryData: PMReportSummaryView;
  centerData: PMCenterBreakdownView[];
  categoryData: PMCategoryBreakdownView[];
}

const PMReportCharts: React.FC<PMReportChartsProps> = ({ summaryData, centerData, categoryData }) => {
  return (
    <Stack spacing={2} sx={{ maxWidth: 1200, mx: 'auto' }}>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
        <PMByCenterChart centerData={centerData} />
        <PMByCategoryChart categoryData={categoryData} />
      </Stack>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
        <PMComplianceByCenterChart centerData={centerData} />
        <PMCostBreakdownChart summaryData={summaryData} />
      </Stack>
    </Stack>
  );
};

export default PMReportCharts;
